<template>
    <div class="wrapper">
        <span class="title">{{ $t('CAMPAIGN_FLOW.TITLE') }}</span>
        <input
            type="text"
            :placeholder="$t('CAMPAIGN_FLOW.SIDEBAR_SEARCH_FIELD.PLACEHOLDER')"
            v-model="searchQuery"
        >
        <ul class="list">
            <li
                v-for="currentCampaign in filteredCampaigns" :key="currentCampaign.id"
                @click="handleSelectedCampaign(currentCampaign)"
                class="item"
                :class="{'selected': selectCampaign && selectCampaign.id === currentCampaign.id}"
                >
                <div class="item-text">
                    <!-- <fluent-icon icon="flash " size="16"/> -->
                    {{ currentCampaign.title }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CampaignsFlowSidebar',
    components: {  },
    data() {
        return {
            selectCampaign: null,
            searchQuery: ''
        };
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
            currentUser: 'getCurrentUser',
            listCampaigns: 'campaignsFlow/getCampaigns'
        }),
        filteredCampaigns() {
            return this.listCampaigns.filter(campaign =>
                campaign.title.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    methods: {
        showAlert(message) {
            bus.$emit('newToastMessage', message);
        },

        handleSelectedCampaign(campaign){
          this.selectCampaign = campaign;
            this.$store.dispatch('campaignsFlow/setCampaign', { campaign });
        }
    }
};
</script>

<style scoped>
.wrapper {
    padding: 8px;
}

.title {
    color: var(--s-700);
    display: flex;
    font-weight: var(--font-weight-bold);
    line-height: var(--space-normal);
    margin: var(--space-small) 0;
    padding: 0 var(--space-small);
    font-size: var(--font-size-small);
}

input {
    margin: 0 0 0 8px;
    height: 3rem;
    width: calc(100% - 16px);
    padding: 8px;
    border: 1px solid var(--s-400);
    border-radius: 4px;
}

.item-text {
    display: inline-flex;
    color: var(--s-600);
    font-weight: var(--font-weight-medium);
    width: calc(100% - 16px);
    height: var(--space-medium);
    padding: var(--space-smaller) var(--space-smaller);
    margin: var(--space-smaller) 0;
    text-align: left;
    line-height: 1.2;
    font-size: 14px;
    gap: 0.3rem;
}
.item-text:hover {
    color: var(--g-20) ;
}

.item {
    cursor: pointer;
    margin: 5px 12px 0 0;
}

.item.selected {
    background-color: var(--w-25);
    border-radius: 8px;
}


.item.selected .item-text {
    color: var(--g-20);
    background-color: black;
    background: fixed;
}
</style>
